export enum GenderName {
  MALE = 'men',
  FEMALE = 'women',
}

export const getCurrentPageGenderContext = (_pathname: string, search: string) => {
  const gender: GenderName | undefined = undefined
  if (search.search(/\bmen\b/) >= 0) {
    return GenderName.MALE
  }

  if (search.search(/\bwomen\b/) >= 0) {
    return GenderName.FEMALE
  }
  if (_pathname.search(/\bmen\b/) >= 0) {
    return GenderName.MALE
  }

  if (_pathname.search(/\bwomen\b/) >= 0) {
    return GenderName.FEMALE
  }
  return gender
}
